import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { expertsWhatIs } from "@/mocks/expertsData";

export default function ExpertsWhatIs() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-start">
            <div>
              <ScrollReveal>
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
                  <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                    / Programme Overview
                  </span>
                </div>
                <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                  {expertsWhatIs.title}
                </h2>
              </ScrollReveal>

              <div className="mt-6 md:mt-8 space-y-4 md:space-y-5">
                {expertsWhatIs.paragraphs.map((para, i) => (
                  <ScrollReveal key={i} delay={i * 100}>
                    <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                      {para}
                    </p>
                  </ScrollReveal>
                ))}
              </div>
            </div>

            <div className="lg:pl-8">
              <ScrollReveal delay={150}>
                <div className="grid grid-cols-2 gap-4 md:gap-5">
                  {expertsWhatIs.highlights.map((h) => (
                    <div
                      key={h.label}
                      className="p-5 md:p-6 rounded-xl bg-tie-grey-light border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300"
                    >
                      <p className="font-serif text-2xl md:text-3xl font-bold text-tie-navy">
                        {h.value}
                      </p>
                      <p className="mt-1.5 text-sm font-semibold text-tie-text-primary">
                        {h.label}
                      </p>
                    </div>
                  ))}
                </div>
              </ScrollReveal>

              <ScrollReveal delay={300}>
                <div className="mt-6 p-5 md:p-6 rounded-xl bg-tie-navy/5 border border-tie-navy/10">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-tie-navy flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-lightbulb-line text-white text-sm" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-tie-text-primary">
                        Why the Experts' Platform Works
                      </p>
                      <p className="mt-1 text-sm text-tie-text-secondary leading-relaxed">
                        The platform works because it verifies expertise before listing it, matches based on real project fit not just credentials, and requires knowledge transfer as part of every engagement. Factories get solutions and capability in one contract.
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}